import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initI18n } from "@qorakul/shared/i18n";
import { App } from "./app/App.tsx";
import "./styles.css";

initI18n();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
